import React, { Component } from 'react';

class ChartDetails extends Component {

    componentDidMount() {
        this.loadChart();
    }

    loadChart() {
        this.props.chart.addEventListener('drill', (ev) => { 
            this.props.onDrill(ev.drillInfo.filters[0], this.props.chartId);
        });

        this.chartDiv.appendChild(this.props.chart.canvas);
        this.props.chart.render();
    }

    render() { 
        return ( 
            <div className="row">
                <div className="col-12 justify-content-center">    
                    <div ref={div => (this.chartDiv = div)} className="pl-3 pr-3 pb-2" />
                </div>
            </div>
         );
    }

}
 
export default ChartDetails;